import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { useCopyToClipboard } from '@modules/common/hooks';
import { WisdomChatDetails } from '@modules/oracle/components/WisdomChatDetails';
import { trackWisdomEvents } from '@modules/oracle/utils';
import { LinkRounded } from '@mui/icons-material';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material';

interface WisdomChatShareModalContentProps {
  chatName?: string;
}

export const WisdomChatShareModalContent = ({
  chatName,
}: WisdomChatShareModalContentProps) => {
  const { closeModal } = useMuiModalContext();

  const copyTextToClipboard = useCopyToClipboard();

  const handleCopyLink = () => {
    copyTextToClipboard(window.location.href);
    closeModal();
    trackWisdomEvents({
      eventName: 'Wisdom - Chat Link Copied',
      chatName,
    });
  };

  return (
    <>
      <ModalHeader title="Copy link to this Chat" />
      <DialogContent dividers>
        <Stack spacing={1}>
          <Box
            component="ul"
            color="text.secondary"
            sx={{
              pl: 2,
            }}
          >
            <Typography variant="caption" component="li" color="inherit">
              Anyone with the link within your organization can view this chat.
            </Typography>
            <Typography variant="caption" component="li" color="inherit">
              Recipients can create a private copy of this chat and ask
              follow-up questions.
            </Typography>
          </Box>
          <WisdomChatDetails titleVariant="h6" logoFontSize="44px" />
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          p: 2,
        }}
      >
        <Button variant="outlined" onClick={() => closeModal()}>
          Cancel
        </Button>
        <Button
          autoFocus
          variant="contained"
          startIcon={<LinkRounded />}
          onClick={handleCopyLink}
        >
          Copy Link
        </Button>
      </DialogActions>
    </>
  );
};
